
export function mapRange(num: number, inMin: number, inMax: number, outMin: number, outMax: number): number {
  const result = mapRangePure(num, inMin, inMax, outMin, outMax);
  if (Number.isNaN(result)) {
    return 0;
  }

  if (result < outMin) {
    return outMin;
  }
  if (result > outMax) {
    return outMax;
  }
  return result;
}

export function mapRangePure(num: number, inMin: number, inMax: number, outMin: number, outMax: number): number {
  return (num - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
}
